import fetch from "auth/FetchInterceptor";
import { env } from "configs/EnvironmentConfig";

const priorityScheduleService = {};

priorityScheduleService.getPrioritySchedules = ({ params }) => {
  const { columnFilter = {}, sort, ...otherParams } = params || {};

  return fetch({
    url: `${env.API_MSP}/priority-schedules`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort,
      keywords: params.keywords || "",
      expand: params?.expand || "",
    },
  });
};

priorityScheduleService.activatePrioritySchedule = ({ id }) => {
  return fetch({
    url: `${env.API_MSP}/priority-schedules/${id}`,
    method: "put",
    data: {
      record_status: "O",
    },
  });
};

priorityScheduleService.deactivatePrioritySchedule = ({ id }) => {
  return fetch({
    url: `${env.API_MSP}/priority-schedules/${id}`,
    method: "delete",
  });
};

priorityScheduleService.createPrioritySchedule = ({ data }) => {
  return fetch({
    url: `${env.API_MSP}/priority-schedules`,
    method: "post",
    data: {
      hub_id: data.hub_id,
      user_type: data?.user_type,
      original_user_id: data?.original_user_id,
      replacement_user_id: data?.replacement_user_id,
      routes: data.routes,
      start_timeslot_id: data?.start_timeslot_id,
      end_timeslot_id: data?.end_timeslot_id,
      priority_start_date: data.priority_start_date,
      priority_end_date: data?.priority_end_date,
      note: data?.note,
    },
  });
};

priorityScheduleService.updatePrioritySchedule = ({ id, data }) => {
  return fetch({
    url: `${env.API_MSP}/priority-schedules/${id}`,
    method: "put",
    data: {
      original_user_id: data.original_user_id,
      replacement_user_id: data.replacement_user_id,
      routes: data.routes,
      start_timeslot_id: data?.start_timeslot_id,
      end_timeslot_id: data?.end_timeslot_id,
      note: data.note,
    },
  });
};
// START RUNNER
priorityScheduleService.listRouteRunner = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/routes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listRouteLocalitiesRunner = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];
  return fetch({
    url: `${env.API_MSP}/route-localities`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listTimeSlotRunner = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/time-slots`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listRunnerHub = function ({ params }) {
  const columnFilter = params.columnFilter || {};
  const hubId = columnFilter.hubId || undefined;

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/ajax/list-runner-hub/${hubId}`,
    method: "get",
    params: {
      ...columnFilter,
      hubId: undefined,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};
// END RUNNER

// START COLLECTOR
priorityScheduleService.listRouteCollector = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/collector/routes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listRouteLocalitiesCollector = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];
  return fetch({
    url: `${env.API_MSP}/collector/route-localities`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listTimeSlotCollector = function ({ params }) {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/collector/time-slots`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

priorityScheduleService.listCollectorHub = function ({ params }) {
  const columnFilter = params.columnFilter || {};
  const hubId = columnFilter.hubId || undefined;

  const defaultFields = [];

  return fetch({
    url: `${env.API_MSP}/ajax/list-collector-hub/${hubId}`,
    method: "get",
    params: {
      ...columnFilter,
      hubId: undefined,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};
// END COLLECTOR

priorityScheduleService.listMyHubs = function ({ params }) {
  return fetch({
    url: `${env.API_MSP}/users/get-my-hubs-list`,
    method: "get",
  });
};

export default priorityScheduleService;
